import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { Table } from '@ztechapps/webui.data-tools'
import { formatMoney } from '@ztechapps/common.utils'
import { LocalDateTime } from '@ztechapps/webui.date'
import { Alert, ShowIf } from '@ztechapps/webui.util'

const Head = () => {
  return (
    <thead>
      <tr>
        <th>Date</th>
        <th>Amount</th>
        <th>Remarks</th>
      </tr>
    </thead>
  )
}

const TableRow = ({ _id, date, amount, remarks, paymentIntent }) => {
  return (
    <tr key={_id}>
      <td>
        <LocalDateTime value={date} />
      </td>
      <td className="">{formatMoney(amount)}</td>

      <td>
        <ShowIf condition={paymentIntent}>
          <a href={`https://dashboard.stripe.com/payments/${paymentIntent}`} target={'_blank'} rel="noreferrer">
            {remarks}
          </a>
        </ShowIf>
        <ShowIf condition={!paymentIntent}>{remarks}</ShowIf>
      </td>
    </tr>
  )
}

export const PaymentList = ({ items }) => {
  if (isEmpty(items)) {
    return (
      <Alert type="warning">
        <h4 className="text-center text-bold">No payment history to show now.</h4>
      </Alert>
    )
  } else {
    return <Table head={<Head />} dataArray={items} row={TableRow} className="table-space-small" />
  }
}
